import MainConnection from "./MainConnection";
import AlertManager from "../utils/AlertManager";

export default {
  requestProductList: async function() {
    try {
      const requestURL = "/products";
      const response = await MainConnection.request().get(requestURL);

      switch (response.data.code) {
        case "0":
          return response.data.data;

        default:
          AlertManager.showErrorDialog(
            response.data.code,
            response.data.message
          );
          break;
      }
    } catch (error) {
      MainConnection.errorMessage(error);
    }
  },
  requestProductById: async function(product_id) {
    try {
      const requestURL = "/products/" + product_id;
      const response = await MainConnection.request().get(requestURL);

      switch (response.data.code) {
        case "0":
          return response.data.data;

        default:
          AlertManager.showErrorDialog(
            response.data.code,
            response.data.message
          );
          break;
      }
    } catch (error) {
      MainConnection.errorMessage(error);
    }
  },
  requestCreateProduct: async function(params) {
    try {
      const requestURL = "/products";
      const response = await MainConnection.request().post(requestURL, params);

      switch (response.data.code) {
        case "0":
          return response.data.data;

        default:
          AlertManager.showErrorDialog(
            response.data.code,
            response.data.message
          );
          break;
      }
    } catch (error) {
      MainConnection.errorMessage(error);
    }
  },
  requestUpdateProductById: async function(product_id, params) {
    try {
      const requestURL = "/products/" + product_id;
      const response = await MainConnection.request().patch(requestURL, params);

      switch (response.data.code) {
        case "0":
          return response.data.data;

        default:
          AlertManager.showErrorDialog(
            response.data.code,
            response.data.message
          );
          break;
      }
    } catch (error) {
      MainConnection.errorMessage(error);
    }
  },
  requestRemoveProductById: async function(product_id) {
    try {
      const requestURL = "/products/" + product_id;
      const response = await MainConnection.request().delete(requestURL);

      switch (response.data.code) {
        case "0":
          return true;

        default:
          AlertManager.showErrorDialog(
            response.data.code,
            response.data.message
          );
          return false;
      }
    } catch (error) {
      MainConnection.errorMessage(error);
    }
  }
};
